import { pageStoreBuilder } from '@/main/store/pages/page/builder';

import { NAME as name } from './constants';

export const store = pageStoreBuilder({
	name,
	crumbLabel: 'edtHeslo',
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
});
